import { ShareSettings } from "../models/share-settings";

export class GetPlanogramShareSettingsRequest{
    planogramId: string = '';
    settings: Partial<ShareSettings>
    constructor(planogramId: string, settings: Partial<ShareSettings>){
        this.planogramId = planogramId;
        this.settings = settings;
    }
}

